export const load = () => ({
	title: 'IndowPRO Installation: Engineered for Profitability & Speed',
	h1: 'Installation, Engineered for Profitability',
	description:
		"Slash project costs with IndowPRO's modular window installation system. Maximize speed, simplify logistics, and eliminate risk for reliable, profitable results.",
	showTitle: true,
});
